import React from 'react'
import { FOV_MODES } from 'helpers/globals'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const aov_modes = [180, 360]

const FovModeButtonBar = ({ presentationValues, currentCamera: { model, fovMode, id, horizontalAngleOfView },
  updateCalculatorAction, toggleSceneSelectorComponent, showSceneSelector, classes, changeCameraModelAction, cameraModels }) => {

  return (
    <div className={classes.container}>
      <div className={classes.topRow}>
        <div className={classes.fovAdjuster}>
          AoV: <strong>{`${presentationValues.angleOfView.value}°`}</strong>
        </div>
        { model && model.is_fisheye
          ? aov_modes.map((mode, i) =>
              <div
                className={horizontalAngleOfView === mode ? classes['activeFisheyeButton'] : classes['fisheyeButton']}
                onClick={_ => horizontalAngleOfView === aov_modes[1-i] && changeCameraModelAction(cameraModels.find(m => m.id === model.id), model.other_fisheye_aov)}
                key={i}
                >
                {aov_modes[i]}
              </div>
            )
          : <div className={classes.buttonBar}>
              { FOV_MODES.map((mode, i) =>
                  <div
                    className={fovMode === mode ? classes[`active${mode}Button`] : classes[`${mode}Button`]}
                    onClick={_ => fovMode === FOV_MODES.find(m => m !== mode) && updateCalculatorAction(mode, 'fovMode', id, false)}
                    key={i}
                  >
                    <FontAwesomeIcon icon={['far', 'image']} key={i} />
                  </div>
                )
              }
            </div>
        }
        <div className={showSceneSelector ? classes.selectScenesToggleActive : classes.selectScenesToggle} onClick={toggleSceneSelectorComponent} >
          Scenes
          <FontAwesomeIcon className={classes.caret} icon={showSceneSelector ? 'caret-up' : 'caret-down'} />
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(FovModeButtonBar)



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovModeButtonBar/index.js